(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5577],{

/***/ 65577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content061": function() { return /* binding */ Content061; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14258);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87900);
/* harmony import */ var _Content061_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98438);
/* harmony import */ var _Content061_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Content061_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var Content061 = function(param) {
    var payload = param.payload;
    var ref, ref1, ref2;
    var ref3;
    var title = (ref3 = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref3 !== void 0 ? ref3 : "";
    var ref4;
    var description = (ref4 = payload === null || payload === void 0 ? void 0 : payload.caption) !== null && ref4 !== void 0 ? ref4 : "";
    var ref5;
    var list = (ref5 = payload === null || payload === void 0 ? void 0 : payload.list) !== null && ref5 !== void 0 ? ref5 : [];
    var ref6;
    var buttonText = (ref6 = payload === null || payload === void 0 ? void 0 : (ref = payload.button) === null || ref === void 0 ? void 0 : ref.buttonText) !== null && ref6 !== void 0 ? ref6 : "";
    var ref7;
    var slug = (ref7 = payload === null || payload === void 0 ? void 0 : (ref1 = payload.button) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.page) === null || ref2 === void 0 ? void 0 : ref2.slug) !== null && ref7 !== void 0 ? ref7 : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Content061_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Content061_module_scss__WEBPACK_IMPORTED_MODULE_3___default().blocks),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Content061_module_scss__WEBPACK_IMPORTED_MODULE_3___default().top),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading3 */ .aC, {
                                as: "h3",
                                className: (_Content061_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__/* .RichText */ .H, {
                                value: description,
                                className: (_Content061_module_scss__WEBPACK_IMPORTED_MODULE_3___default().description),
                                color: "dark"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Content061_module_scss__WEBPACK_IMPORTED_MODULE_3___default().content),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .PageLink */ .H_, {
                                slug: slug,
                                className: (_Content061_module_scss__WEBPACK_IMPORTED_MODULE_3___default().link),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_Content061_module_scss__WEBPACK_IMPORTED_MODULE_3___default().arrow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                                            className: (_Content061_module_scss__WEBPACK_IMPORTED_MODULE_3___default().icon),
                                            name: "arrow_right"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .nv, {
                                        color: "brand",
                                        appearance: "bigger",
                                        className: (_Content061_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["button-text"]),
                                        children: buttonText
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .OrderedList */ .GS, {
                                items: list,
                                className: (_Content061_module_scss__WEBPACK_IMPORTED_MODULE_3___default().list),
                                appearance: "bigger"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content061);


/***/ }),

/***/ 98438:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content061_wrapper__Y3idA","top":"Content061_top__tB3pm","description":"Content061_description__7E6vN","content":"Content061_content__7KCdf","list":"Content061_list__Hj69V","title":"Content061_title__FAuAY","link":"Content061_link__sbsV0","arrow":"Content061_arrow__53Fy5","icon":"Content061_icon__tGihx","button-text":"Content061_button-text__TRCJ6"};

/***/ })

}]);